import { Play } from "lucide-react";
import { Button } from "@component/button";
import {
    Tooltip,
} from "@component/tooltip";
import { InterviewAssessment, PersonaProfile } from "@type/assessments";

interface Props {
    className?: string;
    data: InterviewAssessment
    onStartTestInterview: (persona: PersonaProfile, interviewAssessment: InterviewAssessment) => void;
}

export default function TestInterviewButton(props: Props) {
    const personaProfiles: PersonaProfile[] = [
        {
            level: "Junior",
            name: "Alex",
            cv: "Name: Alex\nEmail: alex.smith@example.com\nEducation: BSc in Computer Science (2020)\nExperience: 1 year as Junior Developer\nSkills: HTML, CSS, JavaScript, React basics\nPortfolio: https://alexsmith.dev"
        },
        {
            level: "Mid-level",
            name: "Jordan Taylor",
            cv: "Name: Jordan Taylor\nEmail: jordan.taylor@example.com\nEducation: MSc in Software Engineering (2018)\nExperience: 4 years in frontend development\nSkills: React, TypeScript, Node.js, Redux, Jest\nPortfolio: https://jordantaylor.dev"
        },
        {
            level: "Senior",
            name: "Casey Morgan",
            cv: "Name: Casey Morgan\nEmail: casey.morgan@example.com\nEducation: BSc in Computer Science (2012)\nExperience: 10 years in software development\nSkills: React, Node.js, Python, AWS, Kubernetes, System Architecture\nPortfolio: https://caseymorgan.dev\nManagement: Led teams of 5-10 developers"
        }
    ];

    return (
        <Tooltip content={(
            <p>
                Test the interview as a candidate to experience the interview process from start to finish.
            </p>
        )}>
            <Button
                variant="outline"
                className={`flex items-center gap-2 font-medium ${props.className}`}
                onClick={() => props.onStartTestInterview(personaProfiles[0], props.data)}
            >
                <Play className="h-4 w-4" />
                Test Interview
            </Button>
        </Tooltip>
    );
}
